"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireWildcard(require("../styled"));
var _excluded = ["onChange", "onBlur", "onFocus", "value", "label", "active", "disabled", "hideLabel", "options"],
  _excluded2 = ["label", "value"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var icon = /*#__PURE__*/_react.default.createElement("svg", {
  width: "11px",
  height: "8px",
  viewBox: "0 0 11 8",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("polygon", {
  id: "Triangle-3",
  fill: "#000000",
  points: "5.5625 7.11853966 0.583984375 0.225210337 10.5410156 0.225210337"
}));
var SelectWrapper = _styled.default.span(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  display: block;\n  background-color: ", ";\n  border-radius: ", ";\n  border: ", " solid ", ";\n  min-width: ", ";\n\n  ", ";\n\n  ", ";\n\n  > svg {\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    z-index: 5;\n    pointer-events: none;\n  }\n"])), (0, _styled.prop)('theme.forms.colors.background'), (0, _styled.prop)('theme.forms.borderRadius'), (0, _styled.rem)(1), (0, _styled.prop)('theme.forms.colors.border'), (0, _styled.rem)(100), function (props) {
  return props.disabled && (0, _styled.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n      opacity: 0.6;\n    "])));
}, function (props) {
  return props.active && (0, _styled.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)(["\n      border: ", " solid ", ";\n      color: ", ";\n    "])), (0, _styled.rem)(1), props.theme.forms.colors.activeBorder, props.theme.forms.colors.active);
}, (0, _styled.rem)(18), (0, _styled.rem)(18));
var StyledSelect = _styled.default.select(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteralLoose2.default)(["\n  appearance: none;\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  min-width: ", ";\n  height: ", ";\n  outline: none;\n  border: 0;\n  padding: 0 ", " 0 ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n\n  color: ", ";\n  background-color: ", ";\n  z-index: 1;\n\n  ", ";\n\n  ::-ms-expand {\n    display: none;\n  }\n\n  > option {\n    font-weight: ", ";\n  }\n"])), (0, _styled.rem)(100), (0, _styled.prop)('theme.forms.height'), (0, _styled.rem)(34), (0, _styled.rem)(12), (0, _styled.prop)('theme.forms.fontFamily'), (0, _styled.prop)('theme.forms.fontSize'), (0, _styled.prop)('theme.forms.fontWeight'), (0, _styled.prop)('theme.forms.height'), (0, _styled.prop)('theme.forms.colors.color'), (0, _styled.prop)('theme.forms.colors.background'), function (props) {
  return props.theme.media.min.sm(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteralLoose2.default)(["font-size:\n      ", ";"])), props.theme.forms.fontSizeDesktop);
}, (0, _styled.prop)('theme.forms.fontWeight'));
var Option = _styled.default.option(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteralLoose2.default)([""])));
var Select = function Select(_ref) {
  var _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? null : _ref$onChange,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? null : _ref$onBlur,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? null : _ref$onFocus,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$hideLabel = _ref.hideLabel,
    hideLabel = _ref$hideLabel === void 0 ? false : _ref$hideLabel,
    options = _ref.options,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(value),
    newValue = _useState[0],
    setNewValue = _useState[1];
  var _useState2 = (0, _react.useState)(active),
    newActive = _useState2[0],
    setNewActive = _useState2[1];
  (0, _react.useEffect)(function () {
    setNewActive(active);
    setNewValue(value);
  }, [value, active]);
  var setFocus = function setFocus(event) {
    setNewActive(true);
    if (onFocus) {
      onFocus(event);
    }
  };
  var unsetFocus = function unsetFocus(event) {
    setNewActive(false);
    if (onBlur) {
      onBlur(event);
    }
  };
  var stateUpdated = function stateUpdated(event) {
    if (onChange) {
      onChange(event);
    }
  };
  var selectOption = function selectOption(event) {
    event.persist();
    setNewValue(event.currentTarget.value, function () {
      return stateUpdated(event);
    });
    if (onBlur) {
      onBlur(event);
    }
  };
  return /*#__PURE__*/_react.default.createElement(SelectWrapper, {
    active: newActive,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(StyledSelect, Object.assign({
    value: newValue,
    options: options,
    onChange: selectOption,
    onFocus: setFocus,
    onBlur: unsetFocus,
    disabled: disabled
  }, rest), label && /*#__PURE__*/_react.default.createElement("option", {
    disabled: true,
    hidden: hideLabel,
    value: ""
  }, label), options.map(function (_ref2, index) {
    var optionLabel = _ref2.label,
      optionValue = _ref2.value,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref2, _excluded2);
    return /*#__PURE__*/_react.default.createElement(Option, Object.assign({
      key: optionLabel,
      value: optionValue
    }, props), optionLabel);
  })), icon);
};
var _default = exports.default = Select;